import React from "react";
import { motion } from "framer-motion";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cartActions } from "../../redux/silces/cartSilces";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../style/product-card.css";
const ProductCard = ({ item }) => {
	const dispatch = useDispatch();
	const addToCart = () => {
		dispatch(
			cartActions.addItem({
				id: item.id,
				productName: item.productName,
				price: item.price,
				imgUrl: item.imgUrl,
				ar:item.ar
			}),
		);
		toast("Product added successfully");
		// alert('product added to the cart ')
	};


	return (
		<Col lg="3" md="4" className="mb-2">
			<div className="product__item">
				<div className="product__img">
					<Link to={`/shop/${item.id}`}>
						<motion.img whileHover={{ scale: 0.9 }} src={item.imgUrl} alt="" />
					</Link>

					<span className="ar">
						<a href={item.ar}>
							<i className="ri-character-recognition-line"></i>{" "}
						</a>
					</span>
				</div>

				<div className="p-2 products__info">
					<h3 className="product__name">
						<Link to={`/shop/${item.id}`}>{item.productName}</Link>
					</h3>
					<span>{item.category}r</span>
				</div>
				<div className="product__card-buttom d-flex align-items-center justify-content-between p-2">
					<span className="price">{item.price}</span>
					<motion.span whileTap={{ scale: 1.2 }} onClick={addToCart}>
						<i className="ri-add-line"></i>
						<ToastContainer />
					</motion.span>
				</div>
			</div>
		</Col>
	);
};

export default ProductCard;
